import axios from "@/lib/axios";
import { Resource } from "@/types/resources";

export type GetEditionResourceByIdRequestParams = {
  editionId: string;
  resourceLibraryId: string;
  resourceId: string;
};

export type GetEditionResourceByIdResponse = Resource;

export const getEditionResourceById = (
  params: GetEditionResourceByIdRequestParams,
) =>
  axios
    .get<GetEditionResourceByIdResponse>(
      `/v1/editions/${params.editionId}/resource-libraries/${params.resourceLibraryId}/resources/${params.resourceId}`,
    )
    .then((res) => res.data);
